import React from 'react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { formatFileSize } from '../../../utils/vacationReceiptFiles';
import { vacationReceiptService } from '../../../services/vacationReceiptService';
import {
    DELETE_LABEL,
    DELETING_LABEL,
    LINKED_REQUEST_LABEL,
    SOURCE_BADGE_CLASSES,
    SOURCE_LABELS,
    VIEW_LABEL,
    formatMoment,
    formatReference,
} from '../vacationReceipts.definitions';
import type { ReceiptRowProps } from '../vacationReceipts.types';

export const ReceiptRow: React.FC<ReceiptRowProps> = ({
    receipt,
    canEdit,
    isDeleting,
    onRequestDelete,
}) => {
    return (
        <tr>
            <td className="py-4 pl-4 pr-3 text-sm sm:pl-6">
                <div className="flex items-start gap-2">
                    <DocumentTextIcon
                        className="mt-0.5 h-5 w-5 shrink-0 text-gray-400"
                        aria-hidden="true"
                    />
                    <div className="min-w-0">
                        <button
                            type="button"
                            onClick={() => void vacationReceiptService.openFile(receipt)}
                            className="font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                        >
                            {receipt.fileName}
                        </button>
                        <p className="text-xs text-gray-500">
                            {formatFileSize(receipt.sizeBytes)}
                            {receipt.note ? ` · ${receipt.note}` : ''}
                        </p>
                    </div>
                </div>
            </td>

            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                {formatReference(receipt.referenceStartDate, receipt.referenceEndDate)}
                {receipt.requestId && (
                    <span className="block text-xs text-gray-400">
                        {receipt.segmentOrder !== null && receipt.segmentOrder !== undefined
                            ? `vinculado ao ${receipt.segmentOrder}º período`
                            : LINKED_REQUEST_LABEL}
                    </span>
                )}
            </td>

            <td className="whitespace-nowrap px-3 py-4 text-sm">
                <span
                    className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${
                        SOURCE_BADGE_CLASSES[receipt.source]
                    }`}
                >
                    {SOURCE_LABELS[receipt.source]}
                </span>
            </td>

            <td className="px-3 py-4 text-sm text-gray-500">
                <span className="block">{receipt.uploadedBy}</span>
                <span className="block text-xs text-gray-400">{formatMoment(receipt.uploadedAt)}</span>
            </td>

            <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm sm:pr-6">
                {isDeleting ? (
                    <span className="text-gray-400">{DELETING_LABEL}</span>
                ) : (
                    <span className="inline-flex items-center gap-3">
                        <button
                            type="button"
                            onClick={() => void vacationReceiptService.openFile(receipt)}
                            className="font-medium text-indigo-600 hover:text-indigo-500"
                        >
                            {VIEW_LABEL}
                        </button>
                        {canEdit && (
                            <button
                                type="button"
                                onClick={() => onRequestDelete(receipt)}
                                className="font-medium text-red-600 hover:text-red-500"
                            >
                                {DELETE_LABEL}
                            </button>
                        )}
                    </span>
                )}
            </td>
        </tr>
    );
};

export default ReceiptRow;
